import type { IconData } from '@stacksjs/iconify-core'

export const cornerDownRight: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M14.058 22a1 1 0 0 1-.707-1.707l3.92-3.921l-3.92-3.922a1 1 0 1 1 1.414-1.414l4.628 4.629a1 1 0 0 1 0 1.414l-4.628 4.628a1 1 0 0 1-.707.293\"/><path fill=\"currentColor\" d=\"M18.686 17.372H9.314a5.006 5.006 0 0 1-5-5V3a1 1 0 0 1 2 0v9.372a3.003 3.003 0 0 0 3 3h9.372a1 1 0 0 1 0 2\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default cornerDownRight
